export default "__VITE_ASSET__c94c097f__"